const THEME_KEY = "cetf-theme";

export function getTheme() {
  try {
    return localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(theme) {
  document.documentElement.classList.toggle("theme-dark", theme === "dark");
  window.dispatchEvent(new CustomEvent("cetf:theme", { detail: theme }));
}

export function toggleTheme() {
  const next = getTheme() === "dark" ? "light" : "dark";
  try {
    localStorage.setItem(THEME_KEY, next);
  } catch {}
  applyTheme(next);
  return next;
}

export function initTheme() {
  applyTheme(getTheme());
}
